import { catalog } from './catalog.js';

export function translate(locale, source, values) {
  if (typeof source !== 'string') return source;
  const key = source.replace(/\s+/g, ' ').trim();
  if (!key) return source;
  const entry = catalog[key];
  const fill = (text) =>
    text.replace(/\{(\w+)\}/g, (token, name) =>
      values?.[name] === undefined ? token : String(values[name])
    );
  const translated =
    locale === 'en' ? entry?.[0] : locale === 'pt-BR' ? entry?.[1] : undefined;
  // Sin traducción (español, o una clave que falta en el catálogo) el texto sale tal
  // cual: los saltos de línea y los espacios importan en bloques con white-space: pre.
  if (translated == null) return fill(source);
  const result = fill(translated);
  return `${/^\s/.test(source) ? ' ' : ''}${result}${/\s$/.test(source) ? ' ' : ''}`;
}
